<script>
import {mapActions} from "pinia";
import {mainSearchStore} from "@/store/mainSearchStore";
import OpinionListItem from "@/components/MainSearch/SearchResult/Opinion/OpinionListItem.vue";
import BaseNoResultMessage from "@/components/BaseNoResultMessage.vue";
import InfiniteLoadingLoader from "@/components/InfiniteLoadingLoader.vue";

export default {
  name: "OrgProfileOpinionsList",
  components: {
    OpinionListItem,
    BaseNoResultMessage,
    InfiniteLoadingLoader
  },
  data() {
    return {
      searchParams: {
        creatorId: this.$route.params.id,
        creatorType: "ORGANIZATION",
        page: 1,
        size: 10,
      },
      opinionsList: [],
      lastItems: false
    }
  },
  methods: {
    ...mapActions(mainSearchStore, [
      'getOpinionsAction'
    ]),
    infiniteHandler($state) {
      if ($state) {
        this.getOpinions($state);
      }
    },
    getOpinions($state) {
      if (!this.lastItems) {
        this.getOpinionsAction(this.searchParams).then((resp) => {
          this.opinionsList = this.opinionsList.concat(resp.data.content);
          this.searchParams.page += 1;
          this.lastItems = resp.data.numberOfElements < this.searchParams.size;

          if ($state) {
            if (this.opinionsList.length === 0) {
              $state.complete();
            } else {
              $state.loaded();
            }
          }
        });
      } else {
        $state.complete();
      }
    }
  }
}
</script>

<template>
  <div class="profile-opinions-list">
    <opinion-list-item v-for="item in opinionsList"
                       :key="item.id"
                       :item-data="item"
    />
    <infinite-loading @infinite="infiniteHandler">
      <template #spinner>
        <InfiniteLoadingLoader v-show="!lastItems"/>
      </template>
      <template #no-more>
        <div></div>
      </template>
      <template #no-results>
        <base-no-result-message :text="$t('profile.noOpinions')"/>
      </template>
    </infinite-loading>
  </div>
</template>